import { FileOutlineIcon } from './FileOutlineIcon';

/**
 * author: Google
 * id 36FCB7D4-D7DE-4B44-BD28-53615689D2C6
 * name file-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-outline.svg
 * tags
 * - Files / Folders 
 */
export const PaperOutlineIcon = FileOutlineIcon;
export default PaperOutlineIcon